import * as actionTypes from "./types";

const initialState = {
  loading: false,
  sucess: false,
  error: null,
  trans_list: null
};

const listTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LIST_TRANSACTION_INITIATED: {
      return { ...state, loading: true };
    }
    case actionTypes.LIST_TRANSACTION_SUCCESS: {
      return {
        ...state,
        loading: false,
        trans_list: action.payload,
        success: true,
        error: null,
      };
    }
    case actionTypes.LIST_TRANSACTION_FAILED: {
      return {
        ...state,
        loading: false,
        trans_list: null,
        success: false,
        error: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default listTransactionReducer;
